export default "__VITE_ASSET__Bjw7mbQc__"